import {
	SET_FORM_STATE
} from '../actions/SiteTrackerActions';

const initialState = {
	formState: {
		values: {},
		isValid: false,
		touched: {},
		errors: {},
	}
};

const siteTrackerReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					default: {
						return state;
					}
	}
};

export default siteTrackerReducer;
